import {Box} from '@mui/material';
import {FC} from 'react';
import {legendStyles as STYLES} from './ServiceRequestByDateStatusLegend.styles';
import {ServiceRequestStatusColorCircle} from '../../../../../ServiceRequests/ui/ServiceRequestStatusColorCircle';
import {ServiceRequestStatusesByDate} from '../../constants/service-requests-statuses-by-date';

export const ServiceRequestByDateStatusLegend: FC = () => {
  return (
    <Box sx={STYLES.container}>
      <ServiceRequestStatusColorCircle status={ServiceRequestStatusesByDate.COMPLETED_ON_TIME} withLabel />
      <ServiceRequestStatusColorCircle status={ServiceRequestStatusesByDate.COMPLETED_NOT_CLOSED} withLabel />
      <ServiceRequestStatusColorCircle status={ServiceRequestStatusesByDate.IN_PROGRESS} withLabel />
      <ServiceRequestStatusColorCircle status={ServiceRequestStatusesByDate.DEADLINE_SOON} withLabel />
      <ServiceRequestStatusColorCircle status={ServiceRequestStatusesByDate.DEADLINE_OVERDUE} withLabel />
    </Box>
  );
};
